import { ReactNode, useMemo } from "react"
import BodyLayout from "./BodyLayout"
import HeaderLayout from "./HeaderLayout"
import TopBar from "./TopBar"

type PageProps = {
	children: ReactNode
	bodyWidth?: number | string
	headerHeight?: number
	headerWidth?: number
}

type PortalRoute = "database" | "devices" | "map" | "clients"
export type LinkData =
	| { linkLabel: string; linkUrl: PortalRoute }
	| { externalUrl: string; linkLabel: string }
export default function Page({
	children,
	bodyWidth = 940,
	headerHeight = 52,
	headerWidth,
}: PageProps) {
	const linksVar: LinkData[] = useMemo(() => {
		return [
			{ linkLabel: "MAP", linkUrl: "map" },
			{ linkLabel: "CLIENTS", linkUrl: "clients" },
			{ linkLabel: "DATABASE", linkUrl: "database" },
			{ linkLabel: "DEVICES", linkUrl: "devices" },
			{ externalUrl: "https://staff.dipai.no", linkLabel: "MAINTENANCE" },
		]
	}, [])

	return (
		<>
			<HeaderLayout
				height={headerHeight}
				bodyWidth={headerWidth ?? bodyWidth}
			>
				<TopBar links={linksVar} />
			</HeaderLayout>
			<div className={`h-[calc(100vh-52px)] overflow-auto`}>
				<BodyLayout
					headerHeight={headerHeight}
					width={"calc(100% - 3rem)"}
				>
					{children}
				</BodyLayout>
			</div>
		</>
	)
}
